import { render } from "./SalesIndexTable.vue?vue&type=template&id=0f6efee7"
import script from "./SalesIndexTable.vue?vue&type=script&lang=js"
export * from "./SalesIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__